import { useMemo } from 'react';
import { PlatformTypes } from '@/types/gql.generated';
import { outlookIntegrationDestination } from '../../addToOutlook/outlookIntegration.destination';
import type { DestinationAvailability } from './availability.lib';

/**
 * The availability of every flag-gated destination. Hand-maintained rather
 * than looping the registry's hook fields (rules of hooks): the registry test
 * pins that exactly the modules read here declare a non-default
 * useIsAvailable, so a new gated destination fails the test until it is added.
 */
export const useDestinationAvailability = (): DestinationAvailability => {
  const outlook = outlookIntegrationDestination.useIsAvailable();

  return useMemo(
    () => ({
      [PlatformTypes.OutlookIntegration]: outlook,
    }),
    [outlook]
  );
};
